import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-bpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationLocationBpamsConstants } from "./create-application-location-bpams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapService } from "../../../../map/shared/map.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiModuleConstants } from "../../../../shared/constants/api-constants/api-module.constants";
import { BehaviorSubject, debounceTime } from "rxjs";
import { PropertyBuildingHeadingEnumHeadingLookup } from "./property-building-heading.model";
import { AddBuildingComponent } from "./add-building/add-building.component";
import { EditBuildingComponent } from "./edit-building/edit-building.component";
import { PopUpComponent } from "../../../../shared/components/pop-up/pop-up.component";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { ViewApplicationLocationBpamsConstants } from "../../../../view-application/modules/bp/view-application-location-bpams/view-application-location-bpams.constants";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { MapServiceConstants } from "../../../../shared/constants/map-service.constants";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { RecipientSelectComponent } from "../../../../shared/components/recipient-components/recipient-select/recipient-select.component";
import { CreateApplicationLocationEcConstants } from "../../ec/create-application-location-ec/create-application-location-ec.constants";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { MapTools } from "../../../../map/shared/map.tools";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
let CreateApplicationLocationBpamsComponent = class CreateApplicationLocationBpamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    modalService;
    searchApplicationsService;
    userInformationService;
    propertiesForm;
    ownersComponentRef;
    descriptionLabel1 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationBpamsConstants.VALIDATION_MESSAGES;
    propertyApplicationDetailsLabel = CreateApplicationLocationBpamsConstants.PROPERTY_APPLICATION_DETAILS_LABEL;
    erfNoControl = CreateApplicationLocationBpamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationBpamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationBpamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationBpamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationBpamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationBpamsConstants.ADDRESS_CONTROL;
    erfSizeControl = CreateApplicationLocationBpamsConstants.ERF_SIZE_CONTROL;
    titleDeedControl = CreateApplicationLocationBpamsConstants.TITLE_DEED_CONTROL;
    zoneControl = CreateApplicationLocationBpamsConstants.ZONE_CONTROL;
    ownerControl = CreateApplicationLocationBpamsConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationBpamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationBpamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationBpamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationBpamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationBpamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationBpamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationBpamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = CreateApplicationLocationBpamsConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = CreateApplicationLocationBpamsConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = CreateApplicationLocationBpamsConstants.ADD_ZONE_LABEL;
    removePropertyLabel = CreateApplicationLocationBpamsConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = CreateApplicationLocationBpamsConstants.OWNER_LABEL;
    copyOwnerLabel = CreateApplicationLocationBpamsConstants.COPY_OWNER_LABEL;
    propertyHeadingLabel = CreateApplicationLocationBpamsConstants.PROPERTY_HEADING_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    fullApplicationCheckRequired = false;
    showOnlyPropertyAndZoningLayers = false;
    titleDeedRestrictionsTextPlaceHolder = CreateApplicationLocationBpamsConstants.TITLE_DEED_RESTRICTION_LABEL;
    titleDeedRestrictionsControl = CreateApplicationLocationBpamsConstants.TITLE_DEED_RESTRICTION_CONTROL;
    propertyDescriptionTextPlaceHolder = CreateApplicationLocationBpamsConstants.PROPERTY_DESCRIPTION_LABEL;
    propertyDescriptionControl = CreateApplicationLocationBpamsConstants.PROPERTY_DESCRIPTION_CONTROL;
    externalWallsTextPlaceHolder = CreateApplicationLocationBpamsConstants.EXTERNAL_WALLS_LABEL;
    internalWallsTextPlaceHolder = CreateApplicationLocationBpamsConstants.INTERNAL_WALLS_LABEL;
    roofingTextPlaceHolder = CreateApplicationLocationBpamsConstants.ROOFING_LABEL;
    numberOfHousesUnitsTextPlaceHolder = CreateApplicationLocationBpamsConstants.NUMBER_OF_HOUSES_UNITS_LABEL;
    externalWallsControl = CreateApplicationLocationBpamsConstants.EXTERNAL_WALLS_CONTROL;
    internalWallsControl = CreateApplicationLocationBpamsConstants.INTERNAL_WALLS_CONTROL;
    roofingControl = CreateApplicationLocationBpamsConstants.ROOFING_CONTROL;
    numberOfHousesUnitsControl = CreateApplicationLocationBpamsConstants.NUMBER_OF_HOUSES_UNITS_CONTROL;
    buildingDetailsLabel = CreateApplicationLocationBpamsConstants.BUILDING_DETAILS_LABEL;
    mainBuildingLabel = CreateApplicationLocationBpamsConstants.MAIN_BUILDING_LABEL;
    outBuildingLabel = CreateApplicationLocationBpamsConstants.OUT_BUILDING_LABEL;
    buildingTotalLabel = CreateApplicationLocationBpamsConstants.BUILDING_TOTAL_LABEL;
    stoepLabel = CreateApplicationLocationBpamsConstants.STOEP_LABEL;
    miscellaneousLabel = CreateApplicationLocationBpamsConstants.MISCELLANEOUS_LABEL;
    totalExistingPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_LABEL;
    totalAddedTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_LABEL;
    totalFloorAreaTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_FLOOR_AREA_LABEL;
    totalExistingControl = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_CONTROL;
    totalAddedControl = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_CONTROL;
    totalFloorAreaControl = CreateApplicationLocationBpamsConstants.TOTAL_FLOOR_AREA_CONTROL;
    // patio
    coveredExistingTextPlaceHolder = CreateApplicationLocationBpamsConstants.COVERED_EXISTING_LABEL;
    coveredAddedTextPlaceHolder = CreateApplicationLocationBpamsConstants.COVERED_ADDED_LABEL;
    openExistingTextPlaceHolder = CreateApplicationLocationBpamsConstants.OPEN_EXISTING_LABEL;
    openAddedTextPlaceHolder = CreateApplicationLocationBpamsConstants.OPEN_ADDED_LABEL;
    totalExistingPatioTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_PATIO_LABEL;
    totalAddedPatioTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_PATIO_LABEL;
    coveredExistingControl = CreateApplicationLocationBpamsConstants.COVERED_EXISTING_CONTROL;
    coveredAddedControl = CreateApplicationLocationBpamsConstants.COVERED_ADDED_CONTROL;
    openExistingControl = CreateApplicationLocationBpamsConstants.OPEN_EXISTING_CONTROL;
    openAddedControl = CreateApplicationLocationBpamsConstants.OPEN_ADDED_CONTROL;
    totalExistingPatioControl = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_PATIO_CONTROL;
    totalAddedPatioControl = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_PATIO_CONTROL;
    // misc
    poolTextPlaceHolder = CreateApplicationLocationBpamsConstants.POOL_LABEL;
    boundaryWallHeightTextPlaceHolder = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_HEIGHT_LABEL;
    boundaryWallRunningTextPlaceHolder = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_RUNNING_LABEL;
    coverageTextPlaceHolder = CreateApplicationLocationBpamsConstants.COVERAGE_LABEL;
    bulkCalculationTextPlaceHolder = CreateApplicationLocationBpamsConstants.BULK_CALCULATION_LABEL;
    calculationsLabel = CreateApplicationLocationBpamsConstants.CALCULATIONS_LABEL;
    poolControl = CreateApplicationLocationBpamsConstants.POOL_CONTROL;
    boundaryWallHeightControl = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_HEIGHT_CONTROL;
    boundaryWallRunningControl = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_RUNNING_CONTROL;
    coverageControl = CreateApplicationLocationBpamsConstants.COVERAGE_CONTROL;
    bulkCalculationControl = CreateApplicationLocationBpamsConstants.BULK_CALCULATION_CONTROL;
    deleteLabel = SharedConstants.REMOVE_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    addLabel = SharedConstants.ADD_LABEL;
    removeDialogTitle = CreateApplicationLocationBpamsConstants.REMOVE_DIALOG_TEXT;
    removeMainContent = `${SharedConstants.REMOVE_MESSAGE} main building(s)?`;
    removeOutContent = `${SharedConstants.REMOVE_MESSAGE} out building(s)?`;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneDocMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    zoneOptions = [];
    externalWallsOptions = [];
    internalWallsOptions = [];
    roofingOptions = [];
    // @ts-ignore
    mainTableMapper;
    // @ts-ignore
    outTableMapper;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    applicantGroups = [];
    mapComponent;
    isMapLoaded = false;
    missingZoneTuple;
    missingZoneList = new Map();
    modalOptions = {
        size: "lg", centered: true, keyboard: false, backdrop: "static"
    };
    selectedApplicationPropertyId = 0;
    showForm = false;
    resubmissionForm;
    verificationMessage = CreateApplicationLocationBpamsConstants.RESUBMISSION_VERIFICATION_MESSAGE;
    verificationMessageFailure = CreateApplicationLocationBpamsConstants.RESUBMISSION_VERIFICATION_MESSAGE_FAILURE;
    resubmissionMessage = CreateApplicationLocationBpamsConstants.RESUBMISSION_MESSAGE;
    previousReferenceNumberLabel = CreateApplicationLocationBpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isExtensionLabel = CreateApplicationLocationBpamsConstants.IS_EXTENSION_LABEL;
    isResubmissionLabel = CreateApplicationLocationBpamsConstants.IS_RESUBMISSION_LABEL;
    verifyLabel = CreateApplicationLocationBpamsConstants.VERIFY_LABEL;
    previousReferenceNumberFormControlName = CreateApplicationLocationBpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isExtensionFormControlName = CreateApplicationLocationBpamsConstants.IS_EXTENSION_FORM_CONTROL_NAME;
    isResubmissionFormControlName = CreateApplicationLocationBpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    supportExtensions = false;
    supportResubmissions = false;
    isExtension = false;
    isResubmission = false;
    isVerified = false;
    showVerify = false;
    showResubmission = false;
    showDetails = true;
    isResubmissionOptions = [];
    isExtensionOptions = [];
    currentUser = null;
    acceptDisclaimerForm;
    acceptFormControlName = CreateApplicationLocationBpamsConstants.ACCEPT_FORM_CONTROL_NAME;
    resubmissionDisclaimerTitle = "";
    resubmissionDisclaimerContent = "";
    acceptVerificationMessage = CreateApplicationLocationBpamsConstants.ACCEPT_RESUBMISSION_VERIFICATION_MESSAGE;
    acceptFormControlLabel = CreateApplicationLocationBpamsConstants.ACCEPT_LABEL;
    titleLabelMessage = CreateApplicationLocationBpamsConstants.RESUBMISSION_DISCLAIMER_TITLE_LABEL_MESSAGE;
    contentLabelMessage = CreateApplicationLocationBpamsConstants.RESUBMISSION_DISCLAIMER_CONTENT_LABEL_MESSAGE;
    acceptResubmissionDisclaimer = false;
    selectedApplicationLocationBpamsSubscription;
    sendMissingLookupsEmailSubscription;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    markStepFormGroupAsTouchedSubscription;
    previousApplicationSubscription;
    currentUserSubscription;
    propertiesFormGroupName = CreateApplicationLocationBpamsConstants.PROPERTIES_FORM_GROUP_NAME;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, mapTools, changeDetectorRefs, modalService, searchApplicationsService, userInformationService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
        this.modalService = modalService;
        this.searchApplicationsService = searchApplicationsService;
        this.userInformationService = userInformationService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.resubmissionDisclaimerTitle = AppConfig.settings.resubmissionDisclaimer.bp.title;
            this.resubmissionDisclaimerContent = AppConfig.settings.resubmissionDisclaimer.bp.content;
            this.resubmissionDisclaimerTitle = AppConfig.settings.resubmissionDisclaimer.bp.title;
            this.resubmissionDisclaimerContent = AppConfig.settings.resubmissionDisclaimer.bp.content;
            if (this.resubmissionDisclaimerTitle === "") {
                this.resubmissionDisclaimerTitle = this.titleLabelMessage;
            }
            if (this.resubmissionDisclaimerContent === "") {
                this.resubmissionDisclaimerContent = this.contentLabelMessage;
            }
        }
        this.initializeColumnToObjectMapping();
    }
    get getProperties() {
        return this.propertiesForm.get("properties");
    }
    ngOnInit() {
        this.initForm();
        this.checkAndInitialiseLookups();
        this.getMetadata();
        this.subscribeToProperty();
        this.subscribeToClearGraphics();
        this.subscribeToCheckFormValidity();
        this.changeDetectorRefs.detectChanges();
        this.currentUserSubscription = this.userInformationService.$authenticatedUser.subscribe({
            next: (user) => {
                this.currentUser = user;
            }
        });
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
        else {
            this.supportResubmissions = false;
        }
        if (this.supportResubmissions && this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = false;
        }
        else if (!this.supportResubmissions && !this.supportExtensions) {
            this.showDetails = true;
            this.showResubmission = false;
            this.showVerify = false;
        }
        else if (this.supportResubmissions && !this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = true;
        }
        else if (!this.supportResubmissions && this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = false;
        }
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.destroyMap();
    }
    loadMetadata(stepMeta) {
        if (stepMeta.extensionOptions !== undefined && stepMeta.extensionOptions !== null) {
            this.supportExtensions = stepMeta.extensionOptions.enabled;
        }
        if (this.supportResubmissions && this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = false;
        }
        else if (!this.supportResubmissions && !this.supportExtensions) {
            this.showDetails = true;
            this.showResubmission = false;
            this.showVerify = false;
        }
        else if (this.supportResubmissions && !this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = true;
        }
        else if (!this.supportResubmissions && this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = false;
        }
        this.changeDetectorRefs.detectChanges();
        this.ownerGroups = stepMeta.ownerGroup;
        this.applicantGroups = stepMeta.applicantGroup;
        this.changeDetectorRefs.markForCheck();
    }
    getZones() {
        return this.getProperties.controls[0].get("zones");
    }
    updatePropertyRequiredFields(newProperty) {
        const erfNoControl = newProperty.get(this.erfNoControl);
        const farmNoControl = newProperty.get(this.farmNoControl);
        const subdivisionControl = newProperty.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") || (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        const sgCodeControl = newProperty.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveZoneClicked(zoneIndex) {
        const controls = this.getZones();
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked() {
        const zonesControl = this.getZones();
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    onBtnRemoveMainClicked() {
        let mainTableSelection = this.getProperties.controls[0].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties.controls[0].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        //  const deletedItem = mainTableSelection;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        const options = {
            size: "xl", centered: true, keyboard: false, backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeMainContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = mainTableSelection;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex) {
                // tslint:disable-next-line:prefer-for-of
                for (let index = 0; index < mainTableSelection.length; index++) {
                    const delIndex = itemsAlreadyOnTable.findIndex(i => i.id === mainTableSelection[index].id);
                    if (delIndex > -1) {
                        itemsAlreadyOnTable.splice(delIndex, 1);
                    }
                }
                for (let index = 0; index < itemsAlreadyOnTable.length; index++) {
                    if (itemsAlreadyOnTable[index].id > 0)
                        continue;
                    itemsAlreadyOnTable[index].id = index !== 0 ? -index : 0;
                }
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                this.getProperties.controls[0].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((error) => {
            this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onBtnEditMainClicked() {
        const mainTableSelection = this.getProperties.controls[0].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties.controls[0].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (mainTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === mainTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit main building";
        modalRef.componentInstance.building = mainTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedbuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedbuilding) {
                itemsAlreadyOnTable[updatedbuilding[0]] = updatedbuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection[0].selected = false;
                this.getProperties.controls[0].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((error) => {
            this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onBtnAddMainClicked() {
        let mainTableSelection = this.getProperties.controls[0].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties.controls[0].get("mainTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add main building";
        modalRef.componentInstance.type = "Main Building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = mainTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                for (let index = 0; index < allItems.length; index++) {
                    if (allItems[index].id > 0)
                        continue;
                    allItems[index].id = index !== 0 ? -index : 0;
                }
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                this.getProperties.controls[0].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((error) => {
            this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onBtnRemoveOutClicked() {
        let outTableSelection = this.getProperties.controls[0].get("outTableSelection").value;
        const outTableDataSource = this.getProperties.controls[0].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        const options = {
            size: "xl", centered: true, keyboard: false, backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeOutContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = outTableSelection;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex) {
                // tslint:disable-next-line:prefer-for-of
                for (let index = 0; index < outTableSelection.length; index++) {
                    const delIndex = itemsAlreadyOnTable.findIndex(i => i.id === outTableSelection[index].id);
                    if (delIndex > -1) {
                        itemsAlreadyOnTable.splice(delIndex, 1);
                    }
                }
                for (let index = 0; index < itemsAlreadyOnTable.length; index++) {
                    if (itemsAlreadyOnTable[index].id > 0)
                        continue;
                    itemsAlreadyOnTable[index].id = index !== 0 ? -index : 0;
                }
                // itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                this.getProperties.controls[0].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((error) => {
            this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onBtnEditOutClicked() {
        const outTableSelection = this.getProperties.controls[0].get("outTableSelection").value;
        const outTableDataSource = this.getProperties.controls[0].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (outTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === outTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit outbuilding";
        modalRef.componentInstance.building = outTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedBuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedBuilding) {
                itemsAlreadyOnTable[updatedBuilding[0]] = updatedBuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection[0].selected = false;
                this.getProperties.controls[0].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((error) => {
            this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onBtnAddOutClicked() {
        let outTableSelection = this.getProperties.controls[0].get("outTableSelection").value;
        const outTableDataSource = this.getProperties.controls[0].get("outTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add outbuilding";
        modalRef.componentInstance.type = "Additional building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = outTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                for (let index = 0; index < allItems.length; index++) {
                    if (allItems[index].id > 0)
                        continue;
                    // allItems[index].id = index!==0 ? -index : 0;
                    // hack for test:
                    allItems[index].id = index !== 0 ? -index - 100 : -100;
                }
                outTableDataSource.next(allItems);
                outTableSelection = [];
                this.getProperties.controls[0].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((error) => {
            this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    mainArrayReturned(array) {
        this.getProperties.controls[0].get("mainTableSelection").setValue(array);
    }
    outArrayReturned(array) {
        this.getProperties.controls[0].get("outTableSelection").setValue(array);
    }
    syncMainBuildings() {
        this.getProperties.controls.forEach(property => {
            const items = property.get("mainTableDataSource").value.getValue();
            const formItems = property.get("mainBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize),
                    buildingNameNumber: new FormControl(item.buildingNameNumber),
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    syncOutBuildings() {
        this.getProperties.controls.forEach(property => {
            const items = property.get("outTableDataSource").value.getValue();
            const formItems = property.get("outBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize),
                    buildingNameNumber: new FormControl(item.buildingNameNumber)
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    calculateTotals() {
        const properties = this.getProperties.controls;
        properties.forEach(property => {
            property.get("coverage").setValue(0);
            property.get("bulkCalculation").setValue(0);
            let totalExistingPatioCalculated = 0.00;
            let totalAddedPatioCalculated = 0.00;
            let totalExistingCalculated = 0.00;
            let totalAddedCalculated = 0.00;
            let totalFloorCalculated = 0.00;
            let totalGroundFloorCalculated = 0.00;
            try {
                if (typeof property.get("coveredExisting").value === "number" && typeof property.get("openExisting").value === "number") {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioOpenExisting = property.get("openExisting").value;
                    totalExistingPatioCalculated += patioCoverageExisting + patioOpenExisting;
                    property.get("totalExistingPatio").setValue(totalExistingPatioCalculated);
                }
                if (typeof property.get("coveredAdded").value === "number" && typeof property.get("openAdded").value === "number") {
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const patioOpenAdded = property.get("openAdded").value;
                    totalAddedPatioCalculated += patioCoverageAdded + patioOpenAdded;
                    property.get("totalAddedPatio").setValue(totalAddedPatioCalculated);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                const mainBuildings = property.get("mainBuildings");
                const outBuildings = property.get("outBuildings");
                mainBuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value === 0) {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                outBuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value === 0) {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                totalFloorCalculated = totalAddedCalculated + totalExistingCalculated;
                property.get("totalExisting").setValue(totalExistingCalculated);
                property.get("totalAdded").setValue(totalAddedCalculated);
                property.get("totalFloorArea").setValue(totalFloorCalculated);
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                if (property.get("coveredExisting").value !== null && property.get("coveredAdded").value !== null && property.get("erfSize").value !== null) {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const totalCoveredPatio = 0.00 + patioCoverageExisting + patioCoverageAdded;
                    const totalCoveredArea = 0.00 + totalExistingCalculated + totalAddedCalculated + totalCoveredPatio;
                    const totalFloorArea = 0.00 + totalGroundFloorCalculated + totalCoveredPatio;
                    const totalArea = 0.00 + property.get("erfSize").value;
                    const bulkCalculation = totalCoveredArea / totalArea;
                    const covered = totalFloorArea / totalArea * 100;
                    property.get("coverage").setValue(Math.round(covered * 100) / 100);
                    property.get("bulkCalculation").setValue(Math.round(bulkCalculation * 100) / 100);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
        });
    }
    setNumberToDecimal(formControl, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        formControl.setValue(decimalValue);
    }
    // this fix is for the "Totals" fields which are not being populated when the form reloads
    syncMainBuildingsOnGet(PropertyFormGroup) {
        const items = PropertyFormGroup.get("mainTableDataSource").value.getValue();
        const formItems = PropertyFormGroup.get("mainBuildings");
        formItems.clear();
        items.forEach(item => {
            const newItem = new FormGroup({
                floor: new FormControl(item.floor),
                existingSize: new FormControl(item.existingSize),
                addedSize: new FormControl(item.addedSize),
                buildingNameNumber: new FormControl(item.buildingNameNumber)
            });
            formItems.push(newItem);
        });
    }
    // this fix is for the "Totals" fields which are not being populated when the form reloads
    syncOutBuildingsOnGet(PropertyFormGroup) {
        const items = PropertyFormGroup.get("outTableDataSource").value.getValue();
        const formItems = PropertyFormGroup.get("outBuildings");
        formItems.clear();
        items.forEach(item => {
            const newItem = new FormGroup({
                floor: new FormControl(item.floor),
                existingSize: new FormControl(item.existingSize),
                addedSize: new FormControl(item.addedSize),
                buildingNameNumber: new FormControl(item.buildingNameNumber)
            });
            formItems.push(newItem);
        });
    }
    subscribeToClearMapGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.mapComponent.removeGraphicsFromMap("Building Plans graphics");
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationLocationBpamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.onGetSelectedApplication();
                CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    initForm() {
        this.resubmissionForm = new FormGroup({
            isResubmission: new FormControl(null, [Validators.required]),
            isExtension: new FormControl(null, [Validators.required]),
            previousReferenceNumber: new FormControl(null)
        });
        this.acceptDisclaimerForm = new FormGroup({
            acceptControl: new FormControl(null),
        });
        this.propertiesForm = this.aflaModuleStrategyService.form.get(this.propertiesFormGroupName);
        const propertyControl = this.getProperties;
        propertyControl.clear();
        const newProperty = new FormGroup({
            id: new FormControl(0),
            property: new FormControl(null),
            erfNo: new FormControl(null),
            subdivision: new FormControl(null),
            allotment: new FormControl(null, [Validators.required]),
            farmNo: new FormControl(null),
            sgCode: new FormControl(null, [Validators.required]),
            address: new FormControl(null, [Validators.required]),
            erfSize: new FormControl(null, [Validators.required]),
            titleDeed: new FormControl(null, [Validators.required]),
            geometry: new FormControl(null, [Validators.required]),
            zones: new FormArray([], [Validators.min(1), Validators.required]), // lookup
            owners: new FormControl(null, [Validators.required]),
            propertyDescription: new FormControl(null, [Validators.required]),
            titleDeedRestrictions: new FormControl(null, [Validators.required]),
            externalWalls: new FormControl(null, [Validators.required]), // lookup
            internalWalls: new FormControl(null, [Validators.required]), // lookup
            roofing: new FormControl(null, [Validators.required]), // lookup
            numberOfHousesUnits: new FormControl(null, [Validators.required]),
            totalExisting: new FormControl({ value: 0, disabled: true }),
            totalAdded: new FormControl({ value: 0, disabled: true }),
            totalFloorArea: new FormControl({ value: 0, disabled: true }),
            // patio
            coveredExisting: new FormControl(null, [Validators.required]),
            coveredAdded: new FormControl(null, [Validators.required]),
            openExisting: new FormControl(null, [Validators.required]),
            openAdded: new FormControl(null, [Validators.required]),
            totalExistingPatio: new FormControl({ value: 0, disabled: true }),
            totalAddedPatio: new FormControl({ value: 0, disabled: true }),
            // misc
            pool: new FormControl(null, [Validators.required]),
            boundaryWallHeight: new FormControl(null, [Validators.required]),
            boundaryWallRunning: new FormControl(null, [Validators.required]),
            coverage: new FormControl({ value: null, disabled: true }),
            bulkCalculation: new FormControl({ value: null, disabled: true }),
            mainBuildings: new FormArray([]),
            outBuildings: new FormArray([]),
            mainTableDataSource: new FormControl(new BehaviorSubject([])),
            mainTableSelection: new FormControl([]),
            outTableDataSource: new FormControl(new BehaviorSubject([])),
            outTableSelection: new FormControl([])
        });
        propertyControl.push(newProperty);
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and (name eq 'PropertyRoofing' or name eq 'ApplicationType' or name eq 'PropertyEstimatedBy' or name eq 'PropertyExternalWalls' or name eq 'PropertyInternalWalls' or name eq 'Zoning')`,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response), error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const externalWalls = [];
        const internalWalls = [];
        const roofings = [];
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PropertyRoofing") {
                    roofings.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyExternalWalls") {
                    externalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyInternalWalls") {
                    internalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zoneOptions", zones);
        this.zoneOptions = zones;
        this.aflaModuleStrategyService.lookups.set("externalWallsOptions", externalWalls);
        this.externalWallsOptions = externalWalls;
        this.aflaModuleStrategyService.lookups.set("internalWallsOptions", internalWalls);
        this.internalWallsOptions = internalWalls;
        this.aflaModuleStrategyService.lookups.set("roofingOptions", roofings);
        this.roofingOptions = roofings;
        this.applicationCreateService.setHasLoadedLookups(true);
        this.isExtensionOptions = [{
                code: SharedConstants.YES_NO_ENUM.Yes,
                value: SharedConstants.YES_NO_ENUM.Yes
            }, { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }];
        this.isResubmissionOptions = [{
                code: SharedConstants.YES_NO_ENUM.Yes,
                value: SharedConstants.YES_NO_ENUM.Yes
            }, { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }];
        this.sortLookups();
        this.changeDetectorRefs.detectChanges();
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = Object.prototype.hasOwnProperty.call(propertyObject, name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = Object.prototype.hasOwnProperty.call(propertyObject, name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = Object.prototype.hasOwnProperty.call(propertyObject, name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    loadExistingProperty(property) {
        this.showForm = false;
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        this.changeDetectorRefs.detectChanges();
        const propertiesFormArray = this.propertiesForm.get("properties");
        propertiesFormArray.clear();
        // propertiesFormArray.updateValueAndValidity();
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        const newProperty = new FormGroup({
            id: new FormControl(this.selectedApplicationPropertyId),
            tempId: new FormControl(this.selectedApplicationPropertyId, Validators.required),
            erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno")),
            subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum")),
            allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment")),
            farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno")),
            sgCode: new FormControl(sgCode, [Validators.required]),
            propertyDescription: new FormControl(null, [Validators.required]),
            titleDeedRestrictions: new FormControl(null, [Validators.required]),
            address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
            erfSize: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfSize", "erfsize"), [Validators.required]),
            titleDeed: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed", "titledeed"), [Validators.required]),
            zones: new FormArray([], [Validators.min(1)]),
            // building details
            externalWalls: new FormControl(null, [Validators.required]),
            internalWalls: new FormControl(null, [Validators.required]),
            roofing: new FormControl(null, [Validators.required]),
            numberOfHousesUnits: new FormControl(null, [Validators.required]),
            // main building
            mainBuildings: new FormArray([]),
            mainTableDataSource: new FormControl(new BehaviorSubject([])),
            mainTableSelection: new FormControl([]), // out/additional building
            outBuildings: new FormArray([]),
            outTableDataSource: new FormControl(new BehaviorSubject([])),
            outTableSelection: new FormControl([]),
            totalExisting: new FormControl({ value: 0, disabled: true }),
            totalAdded: new FormControl({ value: 0, disabled: true }),
            totalFloorArea: new FormControl({ value: 0, disabled: true }),
            // Patio/stoeps
            coveredExisting: new FormControl(0, [Validators.required]),
            coveredAdded: new FormControl(0, [Validators.required]),
            openExisting: new FormControl(0, [Validators.required]),
            openAdded: new FormControl(0, [Validators.required]),
            totalExistingPatio: new FormControl({ value: 0, disabled: true }),
            totalAddedPatio: new FormControl({ value: 0, disabled: true }),
            // Misc.
            pool: new FormControl(0, [Validators.required]),
            boundaryWallHeight: new FormControl(0, [Validators.required]),
            boundaryWallRunning: new FormControl(0, [Validators.required]),
            coverage: new FormControl({ value: 0, disabled: true }),
            bulkCalculation: new FormControl({ value: 0, disabled: true }),
            owners: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required])
        });
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData)
            .subscribe({
            next: (trueCentroidResponse) => {
                newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === MapServiceConstants.PROPERTY_ZONING_LAYER);
                if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
                    const zoningLayer = zoningLayerObj.layer;
                    const zoningQuery = new Query();
                    zoningQuery.where = `SgCode = '${sgCode}'`;
                    zoningQuery.returnGeometry = false;
                    zoningQuery.outFields = ["*"];
                    zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                        // Make sure the grave centroid is within one cemetery boundary
                        const zonesControl = newProperty.get("zones");
                        if (zoneFeatureSet.features.length > 0) {
                            zoneFeatureSet.features.forEach(item => {
                                const zone = CreateApplicationUtils.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                                if (zone !== undefined && zone !== null) {
                                    let foundZone = null;
                                    this.zoneOptions.forEach(zoneItem => {
                                        if (zoneItem.value === zone) {
                                            foundZone = zoneItem;
                                        }
                                    });
                                    if (foundZone !== null) {
                                        zonesControl.push(new FormGroup({
                                            zone: new FormControl(foundZone, [Validators.required])
                                        }));
                                    }
                                    else {
                                        this.appController.showMessage(CreateApplicationLocationBpamsConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Warning);
                                        this.sendEmailMissingLookupForZones([zone]);
                                    }
                                }
                                else {
                                    this.appController.showMessage(CreateApplicationLocationBpamsConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                                }
                            });
                        }
                        if (zonesControl.length === 0) {
                            zonesControl.push(new FormGroup({
                                zone: new FormControl(null, [Validators.required])
                            }));
                        }
                        const propertyControl = this.getProperties;
                        propertyControl.push(newProperty);
                        this.updatePropertyRequiredFields(newProperty);
                        this.showForm = true;
                        this.changeDetectorRefs.detectChanges();
                        this.syncMapGeometries();
                        this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    }, (zoningError) => {
                        this.appController.showMessage(zoningError.message, AlertType.Error);
                        const propertyControl = this.getProperties;
                        propertyControl.push(newProperty);
                        this.updatePropertyRequiredFields(newProperty);
                        this.showForm = true;
                        this.changeDetectorRefs.detectChanges();
                        this.syncMapGeometries();
                        this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    });
                }
                else {
                    const propertyControl = this.getProperties;
                    propertyControl.push(newProperty);
                    this.updatePropertyRequiredFields(newProperty);
                    this.showForm = true;
                    this.changeDetectorRefs.detectChanges();
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                }
            }, error: (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    onGetSelectedApplication() {
        this.showForm = false;
        if (+this.jobId > 0 && this.selectedApplication) {
            this.selectedApplication.properties.sort((a, b) => (a?.id - b?.id));
            const propertyControl = this.getProperties;
            this.selectedApplicationPropertyId = this.selectedApplication.properties[0].id;
            this.missingZoneList = new Map();
            this.applicationCreateService.$missingLookupsForZones = [];
            propertyControl.clear();
            const missingLookupsForZones = [];
            const property = this.selectedApplication.properties[0];
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
            const geom = JsonUtils.fromJSON(geometryArc);
            const newProperty = new FormGroup({
                id: new FormControl(property.id),
                property: new FormControl(property),
                erfNo: new FormControl(property.erfNumber),
                subdivision: new FormControl(property.subdivision),
                allotment: new FormControl(property.allotment, [Validators.required]),
                farmNo: new FormControl(property.farmNumber),
                sgCode: new FormControl(property.sgCode, [Validators.required]),
                address: new FormControl(property.address, [Validators.required]),
                erfSize: new FormControl(property.erfSize, [Validators.required]),
                titleDeed: new FormControl(property.titleDeed, [Validators.required]),
                geometry: new FormControl(geom), centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1), Validators.required]), // lookup
                owners: new FormControl(property.owners, [Validators.required]),
                propertyDescription: new FormControl(property.applicationDescription, [Validators.required]),
                titleDeedRestrictions: new FormControl(property.applicationRestrictions, [Validators.required]),
                externalWalls: new FormControl(null, [Validators.required]), // lookup
                internalWalls: new FormControl(null, [Validators.required]), // lookup
                roofing: new FormControl(null, [Validators.required]), // lookup
                numberOfHousesUnits: new FormControl(property.numberOfHouses, [Validators.required]),
                totalExisting: new FormControl({ value: 0, disabled: true }),
                totalAdded: new FormControl({ value: 0, disabled: true }),
                totalFloorArea: new FormControl({ value: 0, disabled: true }),
                // patio
                coveredExisting: new FormControl(property.patioCoveredExisting, [Validators.required]),
                coveredAdded: new FormControl(property.patioCoveredAdded, [Validators.required]),
                openExisting: new FormControl(property.patioOpenExisting, [Validators.required]),
                openAdded: new FormControl(property.patioOpenAdded, [Validators.required]),
                totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                // misc
                pool: new FormControl(property.pool, [Validators.required]),
                boundaryWallHeight: new FormControl(property.boundaryWallHeight, [Validators.required]),
                boundaryWallRunning: new FormControl(property.boundaryWallRunning, [Validators.required]),
                coverage: new FormControl({ value: property.coverage, disabled: true }),
                bulkCalculation: new FormControl({ value: property.bulkCalculation, disabled: true }),
                mainBuildings: new FormArray([]),
                outBuildings: new FormArray([]),
                mainTableDataSource: new FormControl(new BehaviorSubject([])),
                mainTableSelection: new FormControl([]),
                outTableDataSource: new FormControl(new BehaviorSubject([])),
                outTableSelection: new FormControl([])
            });
            // if property is loaded from an existing application mark for as touched it as touched
            this.propertiesForm.markAllAsTouched();
            const zonesControl = newProperty.get("zones");
            property.zonings.forEach(zone => {
                let foundZone = false;
                this.zoneOptions.forEach(zoneOption => {
                    if (zoneOption.value === zone.zoning) {
                        foundZone = true;
                        const zoneGroup = new FormGroup({
                            id: new FormControl(zone.id),
                            applicationPropertyId: new FormControl(zone.applicationPropertyId),
                            zone: new FormControl(zoneOption, [Validators.required]),
                            deleted: new FormControl(zone.deleted)
                        });
                        zonesControl.push(zoneGroup);
                    }
                });
                if (!foundZone) {
                    missingLookupsForZones.push(zone.zoning);
                    this.applicationCreateService.$missingLookupsForZones.push(zone.zoning);
                }
            });
            if (missingLookupsForZones.length > 0) {
                this.missingZoneTuple = [missingLookupsForZones, false];
                this.missingZoneList.set(0, this.missingZoneTuple);
            }
            const mainTableDataSource = newProperty.get("mainTableDataSource").value;
            const outTableDataSource = newProperty.get("outTableDataSource").value;
            const mainItems = [];
            const outItems = [];
            property.buildings.forEach(building => {
                if (building.type === "Main Building") {
                    mainItems.push(building);
                }
                else {
                    outItems.push(building);
                }
            });
            mainTableDataSource.next(mainItems);
            outTableDataSource.next(outItems);
            let externalWalls = null;
            this.externalWallsOptions.forEach(item => {
                if (item.value === property.externalWalls) {
                    externalWalls = item;
                }
            });
            let internalWalls = null;
            this.internalWallsOptions.forEach(item => {
                if (item.value === property.internalWalls) {
                    internalWalls = item;
                }
            });
            let roofing = null;
            this.roofingOptions.forEach(item => {
                if (item.value === property.roofing) {
                    roofing = item;
                }
            });
            newProperty.get("externalWalls").setValue(externalWalls);
            newProperty.get("internalWalls").setValue(internalWalls);
            newProperty.get("roofing").setValue(roofing);
            // todo Temporary fix:
            this.syncMainBuildingsOnGet(newProperty);
            this.syncOutBuildingsOnGet(newProperty);
            this.calculateTotalsOnGet(newProperty);
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometryArc));
            this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
                next: (response) => {
                    newProperty.get("centroid").setValue(response.results[0].value);
                    propertyControl.push(newProperty);
                    this.updatePropertyRequiredFields(newProperty);
                    this.showForm = true;
                    this.syncMapGeometries();
                    CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                    this.changeDetectorRefs.detectChanges();
                }, error: (error) => {
                    this.appController.handleServerErrorMessage(ViewApplicationLocationBpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
            if (this.selectedApplication.isResubmission) {
                this.resubmissionForm.get("isResubmission").setValue("Yes");
                this.resubmissionForm.get("previousReferenceNumber").setValue(this.selectedApplication.previousReferenceNumber);
                this.showResubmission = true;
                this.isResubmission = true;
            }
            else {
                this.resubmissionForm.get("isResubmission").setValue("No");
            }
            if (this.selectedApplication.isExtension) {
                this.isExtension = true;
                this.resubmissionForm.get("isExtension").setValue("Yes");
                this.resubmissionForm.get("previousReferenceNumber").setValue(this.selectedApplication.previousReferenceNumber);
            }
            else {
                this.resubmissionForm.get("isExtension").setValue("No");
            }
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties.controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Building plans graphics", true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap("Building plans graphics");
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
                // this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    sendEmailMissingLookupForZones(missingLookupsForZones) {
        const url = `${ApiModuleConstants.URL}/${ApiModuleConstants.MISSING_LOOKUP_EMAIL_REQUEST_URL}`;
        const params = {
            moduleId: this.applicationCreateService.moduleID, lookupType: "Zoning", lookupList: missingLookupsForZones
        };
        this.sendMissingLookupsEmailSubscription = this.applicationCreateService.sendMissingLookupsEmail(url, params)
            .subscribe({
            next: () => {
            }, error: (error) => {
                this.appController.handleServerErrorMessage(`${CreateApplicationLocationBpamsConstants.MISSING_ZONE_LABEL_EMAIL_FAILED}`, error, CRUDOperation.Selecting);
            }
        });
    }
    initializeColumnToObjectMapping() {
        this.mainTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
        this.outTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
    }
    // NOTE: This is a Temporary fix - To be changed
    subscribeToClearGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.showForm = false;
                    this.getProperties.clear();
                    this.mapComponent.removeGraphicsFromMap("Building plans graphics");
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    // NOTE: This is a Temporary fix - To be changed
    sortLookups() {
        // sort zones dropdown alphabetically
        this.zoneOptions?.sort((a, b) => (a.value?.localeCompare(b?.value)));
        this.externalWallsOptions?.sort((a, b) => (a.value?.localeCompare(b?.value)));
        this.internalWallsOptions?.sort((a, b) => (a.value?.localeCompare(b?.value)));
        this.roofingOptions?.sort((a, b) => (a.value?.localeCompare(b?.value)));
        this.subscribeToSelectedApplication();
    }
    // NOTE: This is a Temporary fix - To be changed
    // this fix is for the "Totals" fields which are not being populated when the form reloads after a save
    calculateTotalsOnGet(PropertyFormGroup) {
        PropertyFormGroup.get("coverage").setValue(0);
        PropertyFormGroup.get("bulkCalculation").setValue(0);
        let totalExistingPatioCalculated = 0.00;
        let totalAddedPatioCalculated = 0.00;
        let totalExistingCalculated = 0.00;
        let totalAddedCalculated = 0.00;
        let totalFloorCalculated = 0.00;
        let totalGroundFloorCalculated = 0.00;
        try {
            if (PropertyFormGroup.get("coveredExisting").value !== null &&
                PropertyFormGroup.get("coveredAdded").value !== null &&
                PropertyFormGroup.get("openExisting").value !== null &&
                PropertyFormGroup.get("openAdded").value !== null) {
                const patioCoverageExisting = PropertyFormGroup.get("coveredExisting").value;
                const patioCoverageAdded = PropertyFormGroup.get("coveredAdded").value;
                const patioOpenExisting = PropertyFormGroup.get("openExisting").value;
                const patioOpenAdded = PropertyFormGroup.get("openAdded").value;
                totalExistingPatioCalculated += patioCoverageExisting + patioOpenExisting;
                totalAddedPatioCalculated += patioCoverageAdded + patioOpenAdded;
                PropertyFormGroup.get("totalExistingPatio").setValue(totalExistingPatioCalculated);
                PropertyFormGroup.get("totalAddedPatio").setValue(totalAddedPatioCalculated);
            }
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
        try {
            const mainBuildings = PropertyFormGroup.get("mainBuildings");
            const outBuildings = PropertyFormGroup.get("outBuildings");
            mainBuildings.controls.forEach(building => {
                totalExistingCalculated += building.get("existingSize").value;
                totalAddedCalculated += building.get("addedSize").value;
                if (building.get("floor").value === 0) {
                    totalGroundFloorCalculated += building.get("existingSize").value;
                    totalGroundFloorCalculated += building.get("addedSize").value;
                }
            });
            outBuildings.controls.forEach(building => {
                totalExistingCalculated += building.get("existingSize").value;
                totalAddedCalculated += building.get("addedSize").value;
                if (building.get("floor").value === 0) {
                    totalGroundFloorCalculated += building.get("existingSize").value;
                    totalGroundFloorCalculated += building.get("addedSize").value;
                }
            });
            totalFloorCalculated = totalAddedCalculated + totalExistingCalculated;
            PropertyFormGroup.get("totalExisting").setValue(totalExistingCalculated);
            PropertyFormGroup.get("totalAdded").setValue(totalAddedCalculated);
            PropertyFormGroup.get("totalFloorArea").setValue(totalFloorCalculated);
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
        try {
            if (PropertyFormGroup.get("coveredExisting").value !== null &&
                PropertyFormGroup.get("coveredAdded").value !== null &&
                PropertyFormGroup.get("erfSize").value !== null) {
                const patioCoverageExisting = PropertyFormGroup.get("coveredExisting").value;
                const patioCoverageAdded = PropertyFormGroup.get("coveredAdded").value;
                const totalCoveredPatio = 0.00 + patioCoverageExisting + patioCoverageAdded;
                const totalCoveredArea = 0.00 + totalExistingCalculated + totalAddedCalculated + totalCoveredPatio;
                const totalFloorArea = 0.00 + totalGroundFloorCalculated + totalCoveredPatio;
                const totalArea = 0.00 + PropertyFormGroup.get("erfSize").value;
                const bulkCalculation = totalCoveredArea / totalArea;
                const covered = totalFloorArea / totalArea * 100;
                PropertyFormGroup.get("coverage").setValue(Math.round(covered * 100) / 100);
                PropertyFormGroup.get("bulkCalculation").setValue(Math.round(bulkCalculation * 100) / 100);
            }
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
    }
    checkAndInitialiseLookups() {
        this.applicationCreateService.setHasLoadedLookups(false);
        if (this.aflaModuleStrategyService.lookups.has("externalWallsOptions")) {
            this.externalWallsOptions = this.aflaModuleStrategyService.lookups.get("externalWallsOptions");
            this.internalWallsOptions = this.aflaModuleStrategyService.lookups.get("internalWallsOptions");
            this.roofingOptions = this.aflaModuleStrategyService.lookups.get("roofingOptions");
            this.zoneOptions = this.aflaModuleStrategyService.lookups.get("zoneOptions");
            this.sortLookups();
            this.applicationCreateService.setHasLoadedLookups(true);
        }
        else {
            this.getLookups();
        }
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const extensionValue = this.resubmissionForm.get("isExtension").value;
        if (extensionValue === null && this.supportExtensions === true) {
            this.resubmissionForm.updateValueAndValidity();
            this.appController.showMessage("Please select if application is a extension first", AlertType.Warning);
            return;
        }
        const resubmissionValue = this.resubmissionForm.get("isResubmission").value;
        if (resubmissionValue === null && this.supportResubmissions === true) {
            this.resubmissionForm.updateValueAndValidity();
            this.appController.showMessage("Please select if application is a resubmission first", AlertType.Warning);
            return;
        }
        if ((this.aflaModuleStrategyService.previousApplication !== null || extensionValue === null || extensionValue === SharedConstants.YES_NO_ENUM.Yes) && this.supportExtensions === true) {
            this.appController.showMessage(this.resubmissionMessage, AlertType.Warning);
            return;
        }
        if ((this.aflaModuleStrategyService.previousApplication !== null || resubmissionValue === null || resubmissionValue === SharedConstants.YES_NO_ENUM.Yes) && this.supportResubmissions === true) {
            this.appController.showMessage(this.resubmissionMessage, AlertType.Warning);
            return;
        }
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties;
        const erfNoControl = propertyControl.controls[0]?.get(this.erfNoControl);
        const farmNoControl = propertyControl.controls[0]?.get(this.farmNoControl);
        if ((erfNoControl?.value !== undefined && erfNoControl?.value !== null && erfNoControl?.value.trim() !== "") ||
            (farmNoControl?.value !== undefined && farmNoControl?.value !== null && farmNoControl?.value.trim() !== "")) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.showForm = false;
                    this.getProperties.clear();
                    this.mapComponent.clearGraphics("Building plans graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    onCopyOwnerToApplicant() {
        const ownersControl = this.getProperties.controls[0].get(this.ownerControl);
        const selectedOwners = ownersControl.value ? ownersControl.value.filter((x) => x.selected === true) : [];
        if (selectedOwners.length === 0) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.NO_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length > 1) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.MULTIPLE_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length === 1) {
            const applicant = RecipientUtils.buildApplicantStringForUserSettings(selectedOwners[0], this.applicantGroups);
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(applicant);
            this.appController.showMessage("Owner data successfully copied", AlertType.Success);
        }
    }
    subscribeToCheckFormValidity() {
        this.markStepFormGroupAsTouchedSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.propertiesForm && formGroupName === this.propertiesFormGroupName) {
                    if (this.propertiesForm)
                        this.propertiesForm.markAllAsTouched();
                    if (this.ownersComponentRef)
                        this.ownersComponentRef.markAllAsTouched();
                    if (this.changeDetectorRefs)
                        this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    onToggleAccept(event) {
        if (this.aflaModuleStrategyService.previousApplication === null || this.aflaModuleStrategyService.previousApplication === undefined) {
            this.appController.showMessage("Please validate an application before accepting disclaimer", AlertType.Warning);
            this.acceptDisclaimerForm.get(this.acceptFormControlName).setValue(false);
            this.acceptResubmissionDisclaimer = false;
            return;
        }
        const accept = event.target.checked;
        this.acceptResubmissionDisclaimer = accept;
        this.aflaModuleStrategyService.previousApplication.acceptResubmissionDisclaimer = accept;
    }
    onIsExtensionChanged(event) {
        const element = event.target?.value;
        this.aflaModuleStrategyService.previousApplication = null;
        this.acceptResubmissionDisclaimer = null;
        this.resetVerification();
        this.aflaModuleStrategyService.resetForm();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.resubmissionForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.resubmissionForm.get(this.isResubmissionFormControlName).clearValidators();
            this.resubmissionForm.get(this.isResubmissionFormControlName).setValue(null);
            this.resubmissionForm.get(this.isResubmissionFormControlName).disable();
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).enable();
            this.acceptDisclaimerForm.get("acceptControl").clearValidators();
            this.acceptDisclaimerForm.get("acceptControl").setValue(null);
            this.isExtension = true;
            this.isResubmission = false;
            this.isVerified = false;
            this.showResubmission = false;
            this.showDetails = false;
            this.showVerify = true;
        }
        else {
            this.resubmissionForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.resubmissionForm.get(this.isResubmissionFormControlName).setValidators([Validators.required]);
            this.resubmissionForm.get(this.isResubmissionFormControlName).setValue(null);
            this.resubmissionForm.get(this.isResubmissionFormControlName).enable();
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).disable();
            this.acceptDisclaimerForm.get("acceptControl").clearValidators();
            this.acceptDisclaimerForm.get("acceptControl").setValue(null);
            this.isExtension = false;
            this.isResubmission = false;
            this.isVerified = false;
            this.showResubmission = true;
            this.showDetails = false;
            this.showVerify = false;
        }
        this.acceptDisclaimerForm.get("acceptControl").updateValueAndValidity();
        this.resubmissionForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.resubmissionForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onIsResubmissionChanged(event) {
        const element = event.target?.value;
        this.aflaModuleStrategyService.previousApplication = null;
        this.acceptResubmissionDisclaimer = null;
        this.resetVerification();
        this.aflaModuleStrategyService.resetForm();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.resubmissionForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.resubmissionForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).enable();
            this.acceptDisclaimerForm.get("acceptControl").setValidators([Validators.required]);
            this.acceptDisclaimerForm.get("acceptControl").setValue(null);
            this.isExtension = false;
            this.isResubmission = true;
            this.isVerified = false;
            this.showDetails = false;
            this.showVerify = true;
            this.acceptResubmissionDisclaimer = false;
        }
        else {
            this.resubmissionForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.resubmissionForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).disable();
            this.acceptDisclaimerForm.get("acceptControl").clearValidators();
            this.acceptDisclaimerForm.get("acceptControl").setValue(null);
            this.isExtension = false;
            this.isResubmission = false;
            this.isVerified = false;
            this.showDetails = true;
            this.showVerify = false;
            this.acceptResubmissionDisclaimer = false;
        }
        this.acceptDisclaimerForm.get("acceptControl").updateValueAndValidity();
        this.resubmissionForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.resubmissionForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    resetVerification() {
        this.aflaModuleStrategyService.previousApplication = null;
        this.isVerified = false;
        this.showDetails = false;
        this.changeDetectorRefs.detectChanges();
        const propertyControl = this.getProperties;
        this.missingZoneList = new Map();
        this.applicationCreateService.$missingLookupsForZones = [];
        propertyControl.clear();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
        this.propertiesForm.reset();
        /*     if (this.isExtension || this.isResubmission) {
              this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
              this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
              this.resubmissionForm.get(this.previousReferenceNumberFormControlName).enable();
            } else {
              this.resubmissionForm.get(this.previousReferenceNumberFormControlName).clearValidators();
              this.resubmissionForm.get(this.previousReferenceNumberFormControlName).setValue(null);
              this.resubmissionForm.get(this.previousReferenceNumberFormControlName).disable();
            } */
        this.aflaModuleStrategyService.form.reset();
        this.aflaModuleStrategyService.form.get("detailsForm").reset();
        this.aflaModuleStrategyService.form.get("applicantForm").reset();
        this.aflaModuleStrategyService.form.get("applicantAgentForm").reset();
        this.aflaModuleStrategyService.form.get("professionalBodiesForm").reset();
    }
    onVerifyReferenceNumberClicked() {
        this.resetVerification();
        const previousReferenceNumber = this.resubmissionForm.get(this.previousReferenceNumberFormControlName).value;
        if (this.resubmissionForm.invalid) {
            this.resubmissionForm.updateValueAndValidity();
            this.resubmissionForm.get(this.previousReferenceNumberFormControlName).markAsTouched();
            this.changeDetectorRefs.detectChanges();
            return;
        }
        if (previousReferenceNumber !== null || previousReferenceNumber !== "") {
            if (this.isResubmission) {
                const params = {
                    previousReferenceNumber: previousReferenceNumber,
                    isResubmission: this.isResubmission,
                    moduleId: this.appController.selectedModuleID,
                    $expand: `properties($expand=buildings,zonings,owners($expand=groups)),architect($expand=groups),engineer($expand=groups),electricalContractor($expand=groups),applicant($expand=groups),applicantAgent($expand=groups)`
                };
                /*         this.aflaModuleStrategyService.previousApplication = null;
                        this.aflaModuleStrategyService.resetForm();
                        (this.aflaModuleStrategyService.form.get("propertiesForm").get("properties") as FormArray).clear(); */
                this.aflaModuleStrategyService.verifyResubmissionReferenceNumberObservable(params).subscribe({
                    next: data => {
                        this.onVerifySuccess(data);
                    },
                    error: err => {
                        this.onVerifyFailure(err);
                    }
                });
            }
            else if (this.isExtension) {
                const params = {
                    previousReferenceNumber: previousReferenceNumber,
                    isResubmission: this.isResubmission,
                    moduleId: this.appController.selectedModuleID,
                    $expand: `properties($expand=buildings,zonings,owners($expand=groups)),architect($expand=groups),engineer($expand=groups),electricalContractor($expand=groups),applicant($expand=groups),applicantAgent($expand=groups)`
                };
                /*         this.aflaModuleStrategyService.previousApplication = null;
                        this.aflaModuleStrategyService.resetForm();
                        (this.aflaModuleStrategyService.form.get("propertiesForm").get("properties") as FormArray).clear(); */
                this.aflaModuleStrategyService.verifyExtensionReferenceNumberObservable(params).subscribe({
                    next: data => {
                        this.onVerifySuccess(data);
                    },
                    error: err => {
                        this.onVerifyFailure(err);
                    }
                });
            }
        }
    }
    onVerifySuccess(data) {
        if (data !== null) {
            this.showDetails = true;
            this.isVerified = true;
            this.aflaModuleStrategyService.previousApplication = data;
            this.getVerifiedApplication();
            this.appController.showMessage(this.verificationMessage, AlertType.Success);
        }
        else {
            this.appController.showMessage(this.verificationMessageFailure, AlertType.Warning);
            this.isVerified = false;
            this.showDetails = false;
            this.changeDetectorRefs.detectChanges();
        }
    }
    onVerifyFailure(err) {
        if (this.isString(err.error)) {
            this.appController.showMessage(err.error, AlertType.Warning);
        }
        else {
            this.appController.handleServerErrorMessage("verify resubmission", err, CRUDOperation.Get);
        }
        this.isVerified = false;
        this.showDetails = false;
        this.changeDetectorRefs.detectChanges();
    }
    isString(value) {
        return typeof value === "string";
    }
    getVerifiedApplication() {
        const params = {
            $filter: `jobId eq ${this.aflaModuleStrategyService.previousApplication.jobId} and moduleId eq ${this.appController.selectedModuleID}`,
            $expand: `properties($expand=buildings,zonings,owners($expand=groups)),architect($expand=groups),engineer($expand=groups),electricalContractor($expand=groups),applicant($expand=groups),applicantAgent($expand=groups),notes`
        };
        this.previousApplicationSubscription = this.aflaModuleStrategyService.getAllApplicationsQuery(params).pipe(debounceTime(1000)).subscribe((returnValue) => {
            const cleanedResult = this.cleanPreviousApplicationData(returnValue.value[0]);
            const result = cleanedResult;
            //this.selectedApplicationService.setSelectedApplication(result);
            this.aflaModuleStrategyService.previousApplication = result;
            //set location
            const propertyControl = this.getProperties;
            this.missingZoneList = new Map();
            this.applicationCreateService.$missingLookupsForZones = [];
            propertyControl.clear();
            const missingLookupsForZones = [];
            const property = result.properties[0];
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
            const geom = JsonUtils.fromJSON(geometryArc);
            const newProperty = new FormGroup({
                id: new FormControl(property.id),
                property: new FormControl(property),
                erfNo: new FormControl(property.erfNumber),
                subdivision: new FormControl(property.subdivision),
                allotment: new FormControl(property.allotment, [Validators.required]),
                farmNo: new FormControl(property.farmNumber),
                sgCode: new FormControl(property.sgCode, [Validators.required]),
                address: new FormControl(property.address, [Validators.required]),
                erfSize: new FormControl(property.erfSize, [Validators.required]),
                titleDeed: new FormControl(property.titleDeed, [Validators.required]),
                geometry: new FormControl(geom), centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1), Validators.required]), // lookup
                owners: new FormControl(property.owners, [Validators.required]),
                propertyDescription: new FormControl(property.applicationDescription, [Validators.required]),
                titleDeedRestrictions: new FormControl(property.applicationRestrictions, [Validators.required]),
                externalWalls: new FormControl(null, [Validators.required]), // lookup
                internalWalls: new FormControl(null, [Validators.required]), // lookup
                roofing: new FormControl(null, [Validators.required]), // lookup
                numberOfHousesUnits: new FormControl(property.numberOfHouses, [Validators.required]),
                totalExisting: new FormControl({ value: 0, disabled: true }),
                totalAdded: new FormControl({ value: 0, disabled: true }),
                totalFloorArea: new FormControl({ value: 0, disabled: true }),
                // patio
                coveredExisting: new FormControl(property.patioCoveredExisting, [Validators.required]),
                coveredAdded: new FormControl(property.patioCoveredAdded, [Validators.required]),
                openExisting: new FormControl(property.patioOpenExisting, [Validators.required]),
                openAdded: new FormControl(property.patioOpenAdded, [Validators.required]),
                totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                // misc
                pool: new FormControl(property.pool, [Validators.required]),
                boundaryWallHeight: new FormControl(property.boundaryWallHeight, [Validators.required]),
                boundaryWallRunning: new FormControl(property.boundaryWallRunning, [Validators.required]),
                coverage: new FormControl({ value: property.coverage, disabled: true }),
                bulkCalculation: new FormControl({ value: property.bulkCalculation, disabled: true }),
                mainBuildings: new FormArray([]),
                outBuildings: new FormArray([]),
                mainTableDataSource: new FormControl(new BehaviorSubject([])),
                mainTableSelection: new FormControl([]),
                outTableDataSource: new FormControl(new BehaviorSubject([])),
                outTableSelection: new FormControl([])
            });
            // if property is loaded from an existing application mark for as touched it as touched
            this.propertiesForm.markAllAsTouched();
            newProperty.controls.sgCode.disable();
            newProperty.controls.erfNo.disable();
            newProperty.controls.farmNo.disable();
            newProperty.controls.subdivision.disable();
            newProperty.controls.allotment.disable();
            const zonesControl = newProperty.get("zones");
            property.zonings.forEach(zone => {
                let foundZone = false;
                this.zoneOptions.forEach(zoneOption => {
                    if (zoneOption.value === zone.zoning) {
                        foundZone = true;
                        const zoneGroup = new FormGroup({
                            id: new FormControl(zone.id),
                            applicationPropertyId: new FormControl(zone.applicationPropertyId),
                            zone: new FormControl(zoneOption, [Validators.required]),
                            deleted: new FormControl(zone.deleted)
                        });
                        zonesControl.push(zoneGroup);
                    }
                });
                if (!foundZone) {
                    missingLookupsForZones.push(zone.zoning);
                    this.applicationCreateService.$missingLookupsForZones.push(zone.zoning);
                }
            });
            if (missingLookupsForZones.length > 0) {
                this.missingZoneTuple = [missingLookupsForZones, false];
                this.missingZoneList.set(0, this.missingZoneTuple);
            }
            const mainTableDataSource = newProperty.get("mainTableDataSource").value;
            const outTableDataSource = newProperty.get("outTableDataSource").value;
            const mainItems = [];
            const outItems = [];
            property.buildings.forEach(building => {
                if (building.type === "Main Building") {
                    mainItems.push(building);
                }
                else {
                    outItems.push(building);
                }
            });
            mainTableDataSource.next(mainItems);
            outTableDataSource.next(outItems);
            let externalWalls = null;
            this.externalWallsOptions.forEach(item => {
                if (item.value === property.externalWalls) {
                    externalWalls = item;
                }
            });
            let internalWalls = null;
            this.internalWallsOptions.forEach(item => {
                if (item.value === property.internalWalls) {
                    internalWalls = item;
                }
            });
            let roofing = null;
            this.roofingOptions.forEach(item => {
                if (item.value === property.roofing) {
                    roofing = item;
                }
            });
            newProperty.get("externalWalls").setValue(externalWalls);
            newProperty.get("internalWalls").setValue(internalWalls);
            newProperty.get("roofing").setValue(roofing);
            // todo Temporary fix:
            this.syncMainBuildingsOnGet(newProperty);
            this.syncOutBuildingsOnGet(newProperty);
            this.calculateTotalsOnGet(newProperty);
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometryArc));
            this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
                next: (response) => {
                    newProperty.get("centroid").setValue(response.results[0].value);
                    propertyControl.push(newProperty);
                    this.updatePropertyRequiredFields(newProperty);
                    this.showForm = true;
                    this.syncMapGeometries();
                    CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                    this.changeDetectorRefs.detectChanges();
                }, error: (error) => {
                    this.appController.handleServerErrorMessage(ViewApplicationLocationBpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    cleanPreviousApplicationData(application) {
        const app = {};
        if (application) {
            app.applicantAgentNa = application.applicantAgentNa;
            app.architectNa = application.architectNa;
            app.engineerNa = application.engineerNa;
            app.electricalContractorNa = application.electricalContractorNa;
            app.fireConsultantNa = application.fireConsultantNa;
            app.otherProfessionalNa = application.otherProfessionalNa;
            app.decision = application.decision;
            app.isMinorBuildingWork = application.isMinorBuildingWork;
            app.isResidential = application.isResidential;
            app.isAlterations = application.isAlterations;
            app.sector = application.sector;
            app.isRdp = application.isRdp;
            app.buildingUse = application.buildingUse;
            app.tpamsReferenceNumber = application.tpamsReferenceNumber;
            app.applicantAgentNa = application.applicantAgentNa;
            app.description = application.description;
            app.shape = application.shape;
            app.wkid = application.wkid;
            app.moduleId = application.moduleId;
            app.applicationType = application.applicationType;
            app.applicationEstimatedBy = application.applicationEstimatedBy;
            app.applicationEstimatedCost = application.applicationEstimatedCost;
            if (this.resubmissionForm.get("isExtension").value === SharedConstants.YES_NO_ENUM.Yes) {
                app.isExtension = true;
                //app.previousReferenceNumber = this.resubmissionForm.get("previousReferenceNumber").value ?? null;
            }
            else {
                app.isExtension = false;
                //this.resubmissionForm.get("previousReferenceNumber").setValue(null);
            }
            if (this.resubmissionForm.get("isResubmission").value === SharedConstants.YES_NO_ENUM.Yes) {
                app.isResubmission = true;
                //app.previousReferenceNumber = this.resubmissionForm.get("previousReferenceNumber").value ?? null;
            }
            else {
                app.isResubmission = false;
                //this.resubmissionForm.get("previousReferenceNumber").setValue(null);
            }
            if (app.isResubmission || app.isExtension) {
                app.previousReferenceNumber = this.resubmissionForm.get("previousReferenceNumber").value ?? null;
            }
        }
        if (application.properties) {
            let properties = {};
            properties = [];
            application.properties.forEach(p => {
                const property = {};
                property.id = 0;
                property.erfNumber = p.erfNumber;
                property.allotment = p.allotment;
                property.farmNumber = p.farmNumber;
                property.sgCode = p.sgCode;
                property.address = p.address;
                property.erfSize = p.erfSize;
                property.titleDeed = p.titleDeed;
                property.subdivision = p.subdivision;
                property.shape = p.shape;
                property.wkid = p.wkid;
                property.isDummy = p.isDummy;
                property.updateGeometry = p.updateGeometry;
                property.applicationDescription = p.applicationDescription;
                property.applicationRestrictions = p.applicationRestrictions;
                property.externalWalls = p.externalWalls;
                property.internalWalls = p.internalWalls;
                property.roofing = p.roofing;
                property.numberOfHouses = p.numberOfHouses;
                property.patioCoveredExisting = p.patioCoveredExisting;
                property.patioCoveredAdded = p.patioCoveredAdded;
                property.patioOpenExisting = p.patioOpenExisting;
                property.patioOpenAdded = p.patioOpenAdded;
                property.pool = p.pool;
                property.boundaryWallHeight = p.boundaryWallHeight;
                property.boundaryWallRunning = p.boundaryWallRunning;
                property.coverage = p.coverage;
                property.bulkCalculation = p.bulkCalculation;
                if (this.currentUser.id === application.createdUserId) {
                    if (p.owners) {
                        let owners = {};
                        owners = [];
                        p.owners.forEach(o => {
                            const owner = {};
                            owner.clientVatNumber = o.clientVatNumber;
                            owner.setRecipient = o.setRecipient;
                            owner.fullName = o.fullName;
                            owner.id = 0;
                            owner.moduleId = o.moduleId;
                            owner.name = o.name;
                            owner.surname = o.surname;
                            owner.telephone = o.telephone;
                            owner.email = o.email;
                            owner.defaultCommunicationMethod = o.defaultCommunicationMethod;
                            owner.postalAddress = o.postalAddress;
                            owner.designation = o.designation;
                            owner.organisation = o.organisation;
                            owner.streetAddress = o.streetAddress;
                            owner.homePhone = o.homePhone;
                            owner.idNumber = o.idNumber;
                            owner.organisationRegistrationNumber = o.organisationRegistrationNumber;
                            owner.representative = o.representative;
                            owner.fax = o.fax;
                            owner.maritalStatus = o.maritalStatus;
                            owner.relativesFullName = o.relativesFullName;
                            owner.relativesContactNumber = o.relativesContactNumber;
                            owner.relativesAddress = o.relativesAddress;
                            owner.employmentStatus = o.employmentStatus;
                            owner.employersName = o.employersName;
                            owner.employersContactNumber = o.employersContactNumber;
                            owner.employersAddress = o.employersAddress;
                            owner.cellphone = o.cellphone;
                            owner.streetSuburb = o.streetSuburb;
                            owner.streetCity = o.streetCity;
                            owner.streetProvince = o.streetProvince;
                            owner.streetCode = o.streetCode;
                            owner.postalSuburb = o.postalSuburb;
                            owner.postalCity = o.postalCity;
                            owner.postalProvince = o.postalProvince;
                            owner.postalCode = o.postalCode;
                            owner.postalCountry = o.postalCountry;
                            owner.streetCountry = o.streetCountry;
                            owner.professionalBody = o.professionalBody;
                            owner.professionalBodyRegNum = o.professionalBodyRegNum;
                            owner.consolidatedGroup = o.consolidatedGroup;
                            owner.emailField = o.emailField;
                            let groups = {};
                            groups = [];
                            o.groups.forEach(g => {
                                const group = {};
                                group.groupName = g.groupName;
                                group.groupType = g.groupType;
                                groups.push(group);
                            });
                            owner.groups = groups;
                            /*     owner.groupsStringArray?: string[]; */
                            owners.push(owner);
                        });
                        property.owners = owners;
                    }
                }
                if (p.zonings) {
                    let zonings = {};
                    zonings = [];
                    p.zonings.forEach(z => {
                        const zone = {};
                        zone.zoning = z.zoning;
                        zonings.push(zone);
                    });
                    property.zonings = zonings;
                }
                if (p.buildings) {
                    let buildings = {};
                    buildings = [];
                    p.buildings.forEach(b => {
                        const building = {};
                        building.type = b.type;
                        building.floor = b.floor;
                        building.existingSize = b.existingSize;
                        building.addedSize = b.addedSize;
                        building.buildingNameNumber = b.buildingNameNumber;
                        buildings.push(building);
                    });
                    property.buildings = buildings;
                }
                properties.push(property);
            });
            app.properties = properties;
        }
        if (this.currentUser.id === application.createdUserId) {
            if (application.applicant) {
                let applicants = {};
                applicants = [];
                application.applicant.forEach(a => {
                    const applicant = {};
                    applicant.clientVatNumber = a.clientVatNumber;
                    applicant.setRecipient = a.setRecipient;
                    applicant.fullName = a.fullName;
                    applicant.id = 0;
                    applicant.moduleId = a.moduleId;
                    applicant.name = a.name;
                    applicant.surname = a.surname;
                    applicant.telephone = a.telephone;
                    applicant.email = a.email;
                    applicant.defaultCommunicationMethod = a.defaultCommunicationMethod;
                    applicant.postalAddress = a.postalAddress;
                    applicant.designation = a.designation;
                    applicant.organisation = a.organisation;
                    applicant.streetAddress = a.streetAddress;
                    applicant.homePhone = a.homePhone;
                    applicant.idNumber = a.idNumber;
                    applicant.organisationRegistrationNumber = a.organisationRegistrationNumber;
                    applicant.representative = a.representative;
                    applicant.fax = a.fax;
                    applicant.maritalStatus = a.maritalStatus;
                    applicant.relativesFullName = a.relativesFullName;
                    applicant.relativesContactNumber = a.relativesContactNumber;
                    applicant.relativesAddress = a.relativesAddress;
                    applicant.employmentStatus = a.employmentStatus;
                    applicant.employersName = a.employersName;
                    applicant.employersContactNumber = a.employersContactNumber;
                    applicant.employersAddress = a.employersAddress;
                    applicant.cellphone = a.cellphone;
                    applicant.streetSuburb = a.streetSuburb;
                    applicant.streetCity = a.streetCity;
                    applicant.streetProvince = a.streetProvince;
                    applicant.streetCode = a.streetCode;
                    applicant.postalSuburb = a.postalSuburb;
                    applicant.postalCity = a.postalCity;
                    applicant.postalProvince = a.postalProvince;
                    applicant.postalCode = a.postalCode;
                    applicant.postalCountry = a.postalCountry;
                    applicant.streetCountry = a.streetCountry;
                    applicant.professionalBody = a.professionalBody;
                    applicant.professionalBodyRegNum = a.professionalBodyRegNum;
                    applicant.consolidatedGroup = a.consolidatedGroup;
                    applicant.emailField = a.emailField;
                    let groups = {};
                    groups = [];
                    a.groups.forEach(g => {
                        const group = {};
                        group.groupName = g.groupName;
                        group.groupType = g.groupType;
                        groups.push(group);
                    });
                    applicant.groups = groups;
                    /*      owner.groupsStringArray?: string[]; */
                    applicants.push(applicant);
                });
                app.applicant = applicants;
            }
        }
        if (this.currentUser.id === application.createdUserId) {
            if (application.applicantAgent) {
                let applicantAgents = {};
                applicantAgents = [];
                application.applicantAgent.forEach(a => {
                    const applicantAgent = {};
                    applicantAgent.clientVatNumber = a.clientVatNumber;
                    applicantAgent.setRecipient = a.setRecipient;
                    applicantAgent.fullName = a.fullName;
                    applicantAgent.id = 0;
                    applicantAgent.moduleId = a.moduleId;
                    applicantAgent.name = a.name;
                    applicantAgent.surname = a.surname;
                    applicantAgent.telephone = a.telephone;
                    applicantAgent.email = a.email;
                    applicantAgent.defaultCommunicationMethod = a.defaultCommunicationMethod;
                    applicantAgent.postalAddress = a.postalAddress;
                    applicantAgent.designation = a.designation;
                    applicantAgent.organisation = a.organisation;
                    applicantAgent.streetAddress = a.streetAddress;
                    applicantAgent.homePhone = a.homePhone;
                    applicantAgent.idNumber = a.idNumber;
                    applicantAgent.organisationRegistrationNumber = a.organisationRegistrationNumber;
                    applicantAgent.representative = a.representative;
                    applicantAgent.fax = a.fax;
                    applicantAgent.maritalStatus = a.maritalStatus;
                    applicantAgent.relativesFullName = a.relativesFullName;
                    applicantAgent.relativesContactNumber = a.relativesContactNumber;
                    applicantAgent.relativesAddress = a.relativesAddress;
                    applicantAgent.employmentStatus = a.employmentStatus;
                    applicantAgent.employersName = a.employersName;
                    applicantAgent.employersContactNumber = a.employersContactNumber;
                    applicantAgent.employersAddress = a.employersAddress;
                    applicantAgent.cellphone = a.cellphone;
                    applicantAgent.streetSuburb = a.streetSuburb;
                    applicantAgent.streetCity = a.streetCity;
                    applicantAgent.streetProvince = a.streetProvince;
                    applicantAgent.streetCode = a.streetCode;
                    applicantAgent.postalSuburb = a.postalSuburb;
                    applicantAgent.postalCity = a.postalCity;
                    applicantAgent.postalProvince = a.postalProvince;
                    applicantAgent.postalCode = a.postalCode;
                    applicantAgent.postalCountry = a.postalCountry;
                    applicantAgent.streetCountry = a.streetCountry;
                    applicantAgent.professionalBody = a.professionalBody;
                    applicantAgent.professionalBodyRegNum = a.professionalBodyRegNum;
                    applicantAgent.consolidatedGroup = a.consolidatedGroup;
                    applicantAgent.emailField = a.emailField;
                    let groups = {};
                    groups = [];
                    a.groups.forEach(g => {
                        const group = {};
                        group.groupName = g.groupName;
                        group.groupType = g.groupType;
                        groups.push(group);
                    });
                    applicantAgent.groups = groups;
                    /*      owner.groupsStringArray?: string[]; */
                    applicantAgents.push(applicantAgent);
                });
                app.applicantAgent = applicantAgents;
            }
        }
        if (application.architect) {
            let architects = {};
            architects = [];
            application.architect.forEach(a => {
                const architect = {};
                architect.clientVatNumber = a.clientVatNumber;
                architect.setRecipient = a.setRecipient;
                architect.fullName = a.fullName;
                architect.id = 0;
                architect.moduleId = a.moduleId;
                architect.name = a.name;
                architect.surname = a.surname;
                architect.telephone = a.telephone;
                architect.email = a.email;
                architect.defaultCommunicationMethod = a.defaultCommunicationMethod;
                architect.postalAddress = a.postalAddress;
                architect.designation = a.designation;
                architect.organisation = a.organisation;
                architect.streetAddress = a.streetAddress;
                architect.homePhone = a.homePhone;
                architect.idNumber = a.idNumber;
                architect.organisationRegistrationNumber = a.organisationRegistrationNumber;
                architect.representative = a.representative;
                architect.fax = a.fax;
                architect.maritalStatus = a.maritalStatus;
                architect.relativesFullName = a.relativesFullName;
                architect.relativesContactNumber = a.relativesContactNumber;
                architect.relativesAddress = a.relativesAddress;
                architect.employmentStatus = a.employmentStatus;
                architect.employersName = a.employersName;
                architect.employersContactNumber = a.employersContactNumber;
                architect.employersAddress = a.employersAddress;
                architect.cellphone = a.cellphone;
                architect.streetSuburb = a.streetSuburb;
                architect.streetCity = a.streetCity;
                architect.streetProvince = a.streetProvince;
                architect.streetCode = a.streetCode;
                architect.postalSuburb = a.postalSuburb;
                architect.postalCity = a.postalCity;
                architect.postalProvince = a.postalProvince;
                architect.postalCode = a.postalCode;
                architect.postalCountry = a.postalCountry;
                architect.streetCountry = a.streetCountry;
                architect.professionalBody = a.professionalBody;
                architect.professionalBodyRegNum = a.professionalBodyRegNum;
                architect.consolidatedGroup = a.consolidatedGroup;
                architect.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                architect.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                architects.push(architect);
            });
            app.architect = architects;
        }
        if (application.engineer) {
            let engineers = {};
            engineers = [];
            application.engineer.forEach(a => {
                const engineer = {};
                engineer.clientVatNumber = a.clientVatNumber;
                engineer.setRecipient = a.setRecipient;
                engineer.fullName = a.fullName;
                engineer.id = 0;
                engineer.moduleId = a.moduleId;
                engineer.name = a.name;
                engineer.surname = a.surname;
                engineer.telephone = a.telephone;
                engineer.email = a.email;
                engineer.defaultCommunicationMethod = a.defaultCommunicationMethod;
                engineer.postalAddress = a.postalAddress;
                engineer.designation = a.designation;
                engineer.organisation = a.organisation;
                engineer.streetAddress = a.streetAddress;
                engineer.homePhone = a.homePhone;
                engineer.idNumber = a.idNumber;
                engineer.organisationRegistrationNumber = a.organisationRegistrationNumber;
                engineer.representative = a.representative;
                engineer.fax = a.fax;
                engineer.maritalStatus = a.maritalStatus;
                engineer.relativesFullName = a.relativesFullName;
                engineer.relativesContactNumber = a.relativesContactNumber;
                engineer.relativesAddress = a.relativesAddress;
                engineer.employmentStatus = a.employmentStatus;
                engineer.employersName = a.employersName;
                engineer.employersContactNumber = a.employersContactNumber;
                engineer.employersAddress = a.employersAddress;
                engineer.cellphone = a.cellphone;
                engineer.streetSuburb = a.streetSuburb;
                engineer.streetCity = a.streetCity;
                engineer.streetProvince = a.streetProvince;
                engineer.streetCode = a.streetCode;
                engineer.postalSuburb = a.postalSuburb;
                engineer.postalCity = a.postalCity;
                engineer.postalProvince = a.postalProvince;
                engineer.postalCode = a.postalCode;
                engineer.postalCountry = a.postalCountry;
                engineer.streetCountry = a.streetCountry;
                engineer.professionalBody = a.professionalBody;
                engineer.professionalBodyRegNum = a.professionalBodyRegNum;
                engineer.consolidatedGroup = a.consolidatedGroup;
                engineer.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                engineer.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                engineers.push(engineer);
            });
            app.engineer = engineers;
        }
        if (application.electricalContractor) {
            let electricalContractors = {};
            electricalContractors = [];
            application.electricalContractor.forEach(a => {
                const electricalContractor = {};
                electricalContractor.clientVatNumber = a.clientVatNumber;
                electricalContractor.setRecipient = a.setRecipient;
                electricalContractor.fullName = a.fullName;
                electricalContractor.id = 0;
                electricalContractor.moduleId = a.moduleId;
                electricalContractor.name = a.name;
                electricalContractor.surname = a.surname;
                electricalContractor.telephone = a.telephone;
                electricalContractor.email = a.email;
                electricalContractor.defaultCommunicationMethod = a.defaultCommunicationMethod;
                electricalContractor.postalAddress = a.postalAddress;
                electricalContractor.designation = a.designation;
                electricalContractor.organisation = a.organisation;
                electricalContractor.streetAddress = a.streetAddress;
                electricalContractor.homePhone = a.homePhone;
                electricalContractor.idNumber = a.idNumber;
                electricalContractor.organisationRegistrationNumber = a.organisationRegistrationNumber;
                electricalContractor.representative = a.representative;
                electricalContractor.fax = a.fax;
                electricalContractor.maritalStatus = a.maritalStatus;
                electricalContractor.relativesFullName = a.relativesFullName;
                electricalContractor.relativesContactNumber = a.relativesContactNumber;
                electricalContractor.relativesAddress = a.relativesAddress;
                electricalContractor.employmentStatus = a.employmentStatus;
                electricalContractor.employersName = a.employersName;
                electricalContractor.employersContactNumber = a.employersContactNumber;
                electricalContractor.employersAddress = a.employersAddress;
                electricalContractor.cellphone = a.cellphone;
                electricalContractor.streetSuburb = a.streetSuburb;
                electricalContractor.streetCity = a.streetCity;
                electricalContractor.streetProvince = a.streetProvince;
                electricalContractor.streetCode = a.streetCode;
                electricalContractor.postalSuburb = a.postalSuburb;
                electricalContractor.postalCity = a.postalCity;
                electricalContractor.postalProvince = a.postalProvince;
                electricalContractor.postalCode = a.postalCode;
                electricalContractor.postalCountry = a.postalCountry;
                electricalContractor.streetCountry = a.streetCountry;
                electricalContractor.professionalBody = a.professionalBody;
                electricalContractor.professionalBodyRegNum = a.professionalBodyRegNum;
                electricalContractor.consolidatedGroup = a.consolidatedGroup;
                electricalContractor.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                electricalContractor.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                electricalContractors.push(electricalContractor);
            });
            app.electricalContractor = electricalContractors;
        }
        if (application.fireConsultant) {
            let fireConsultants = {};
            fireConsultants = [];
            application.fireConsultant.forEach(a => {
                const fireConsultant = {};
                fireConsultant.clientVatNumber = a.clientVatNumber;
                fireConsultant.setRecipient = a.setRecipient;
                fireConsultant.fullName = a.fullName;
                fireConsultant.id = 0;
                fireConsultant.moduleId = a.moduleId;
                fireConsultant.name = a.name;
                fireConsultant.surname = a.surname;
                fireConsultant.telephone = a.telephone;
                fireConsultant.email = a.email;
                fireConsultant.defaultCommunicationMethod = a.defaultCommunicationMethod;
                fireConsultant.postalAddress = a.postalAddress;
                fireConsultant.designation = a.designation;
                fireConsultant.organisation = a.organisation;
                fireConsultant.streetAddress = a.streetAddress;
                fireConsultant.homePhone = a.homePhone;
                fireConsultant.idNumber = a.idNumber;
                fireConsultant.organisationRegistrationNumber = a.organisationRegistrationNumber;
                fireConsultant.representative = a.representative;
                fireConsultant.fax = a.fax;
                fireConsultant.maritalStatus = a.maritalStatus;
                fireConsultant.relativesFullName = a.relativesFullName;
                fireConsultant.relativesContactNumber = a.relativesContactNumber;
                fireConsultant.relativesAddress = a.relativesAddress;
                fireConsultant.employmentStatus = a.employmentStatus;
                fireConsultant.employersName = a.employersName;
                fireConsultant.employersContactNumber = a.employersContactNumber;
                fireConsultant.employersAddress = a.employersAddress;
                fireConsultant.cellphone = a.cellphone;
                fireConsultant.streetSuburb = a.streetSuburb;
                fireConsultant.streetCity = a.streetCity;
                fireConsultant.streetProvince = a.streetProvince;
                fireConsultant.streetCode = a.streetCode;
                fireConsultant.postalSuburb = a.postalSuburb;
                fireConsultant.postalCity = a.postalCity;
                fireConsultant.postalProvince = a.postalProvince;
                fireConsultant.postalCode = a.postalCode;
                fireConsultant.postalCountry = a.postalCountry;
                fireConsultant.streetCountry = a.streetCountry;
                fireConsultant.professionalBody = a.professionalBody;
                fireConsultant.professionalBodyRegNum = a.professionalBodyRegNum;
                fireConsultant.consolidatedGroup = a.consolidatedGroup;
                fireConsultant.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                fireConsultant.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                fireConsultants.push(fireConsultant);
            });
            app.fireConsultant = fireConsultants;
        }
        if (application.otherProfessional) {
            let otherProfessionals = {};
            otherProfessionals = [];
            application.otherProfessional.forEach(a => {
                const otherProfessional = {};
                otherProfessional.clientVatNumber = a.clientVatNumber;
                otherProfessional.setRecipient = a.setRecipient;
                otherProfessional.fullName = a.fullName;
                otherProfessional.id = 0;
                otherProfessional.moduleId = a.moduleId;
                otherProfessional.name = a.name;
                otherProfessional.surname = a.surname;
                otherProfessional.telephone = a.telephone;
                otherProfessional.email = a.email;
                otherProfessional.defaultCommunicationMethod = a.defaultCommunicationMethod;
                otherProfessional.postalAddress = a.postalAddress;
                otherProfessional.designation = a.designation;
                otherProfessional.organisation = a.organisation;
                otherProfessional.streetAddress = a.streetAddress;
                otherProfessional.homePhone = a.homePhone;
                otherProfessional.idNumber = a.idNumber;
                otherProfessional.organisationRegistrationNumber = a.organisationRegistrationNumber;
                otherProfessional.representative = a.representative;
                otherProfessional.fax = a.fax;
                otherProfessional.maritalStatus = a.maritalStatus;
                otherProfessional.relativesFullName = a.relativesFullName;
                otherProfessional.relativesContactNumber = a.relativesContactNumber;
                otherProfessional.relativesAddress = a.relativesAddress;
                otherProfessional.employmentStatus = a.employmentStatus;
                otherProfessional.employersName = a.employersName;
                otherProfessional.employersContactNumber = a.employersContactNumber;
                otherProfessional.employersAddress = a.employersAddress;
                otherProfessional.cellphone = a.cellphone;
                otherProfessional.streetSuburb = a.streetSuburb;
                otherProfessional.streetCity = a.streetCity;
                otherProfessional.streetProvince = a.streetProvince;
                otherProfessional.streetCode = a.streetCode;
                otherProfessional.postalSuburb = a.postalSuburb;
                otherProfessional.postalCity = a.postalCity;
                otherProfessional.postalProvince = a.postalProvince;
                otherProfessional.postalCode = a.postalCode;
                otherProfessional.postalCountry = a.postalCountry;
                otherProfessional.streetCountry = a.streetCountry;
                otherProfessional.professionalBody = a.professionalBody;
                otherProfessional.professionalBodyRegNum = a.professionalBodyRegNum;
                otherProfessional.consolidatedGroup = a.consolidatedGroup;
                otherProfessional.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                otherProfessional.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                otherProfessionals.push(otherProfessional);
            });
            app.otherProfessional = otherProfessionals;
        }
        return app;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef },
        { type: NgbModal },
        { type: SearchApplicationsService },
        { type: UserInformationService }
    ];
    static propDecorators = {
        ownersComponentRef: [{ type: ViewChild, args: [RecipientSelectComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationBpamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-bpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationBpamsComponent);
export { CreateApplicationLocationBpamsComponent };
